export const validateNameInput = (value: string) => {
  const regex = /^[a-zA-Z ]+$/;
  const newValue = value.trimStart().replace('  ', ' ');
  return regex.test(newValue)
    ? newValue
    : newValue
        .replace(/[^a-zA-Z ]/g, '')
        .replace(/ {2,}/g, ' ')
        .trim();
};
